import { motion } from "framer-motion";
import { useBooking } from "../context/BookingContext";
import { useLang } from "../context/LanguageContext";

const CTABanner = () => {
  const { openBooking } = useBooking();
  const { t } = useLang();

  return (
    <section data-testid="cta-banner" className="border-t border-engraved bg-paper-cream">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-8"
      >
        <p className="eyebrow">{t("cta.eyebrow")}</p>
        <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-5xl">
          {t("cta.h2a")}<br />{t("cta.h2b")}
        </h2>
        <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-slate-600">
          {t("cta.body")}
        </p>
        <button
          data-testid="cta-schedule-button"
          onClick={() => openBooking({ service: "qualification" })}
          className="mt-9 bg-navy px-9 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-paper transition-colors duration-300 hover:bg-crimson"
        >
          {t("cta.button")}
        </button>
      </motion.div>
    </section>
  );
};

export default CTABanner;
